import React from 'react';

import ContactFormValidation from './ContactFormValidation';
import ContactFormValidationRules from './ContactFormValidationRules';

var fieldsvalues = {
  name: '',
  number: '',
  email: '',
  companyname: '',
  webapp: '',
  mobileapp: '',
  developer: '',
  message: '',
};

const ContactForm = (props) => {
  const { handleSubmit, handleChange, handleCheckBoxChange, values, errors, isSubmitting } = ContactFormValidation(
    fieldsvalues,
    ContactFormValidationRules
  );

  const IndexTitle = () => {
    return (
      <>
        <h2 className="font-weight-normal mb-2">Get a free quote</h2>
        <p>Talk to our consultants by filling in the form.</p>
      </>
    );
  };

  const ContactTitle = () => {
    return (
      <>
        <h2 className="font-weight-normal mb-2">Let’s Get In Touch!</h2>
        <p>
          If you got any questions, please do not hesitate to send us a message. <br />
          We are looking forward to hear from you!
        </p>
      </>
    );
  };

  return (
    <section className="pt-lg-9 pt-0 pb-7">
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <div className="mb-md-6 mb-5">{props.page === 'contact' ? <ContactTitle /> : <IndexTitle />}</div>
            <form className="row mt-6" name="quote" onSubmit={handleSubmit}>
              <div className="form-group col-md-6 mb-5">
                <input
                  type="text"
                  name="name"
                  id="name"
                  onChange={(e) => handleChange(e)}
                  value={values.name}
                  className={errors.name ? 'form-control is-invalid' : 'form-control'}
                  placeholder="Your Full Name"
                />
                {errors.name && <p className="text-danger">{errors.name}</p>}
              </div>
              <div className="form-group col-md-6 mb-5">
                <input
                  type="text"
                  name="number"
                  id="number"
                  onChange={(e) => handleChange(e)}
                  value={values.number}
                  className={errors.number ? 'form-control is-invalid' : 'form-control'}
                  placeholder="Your Phone Number"
                />
                {errors.number && <p className="text-danger">{errors.number}</p>}
              </div>
              <div className="form-group col-md-6 mb-5">
                <input
                  type="email"
                  name="email"
                  id="email"
                  onChange={(e) => handleChange(e)}
                  value={values.email}
                  className={errors.email ? 'form-control is-invalid' : 'form-control'}
                  placeholder="Your Email Address"
                />
                {errors.email && <p className="text-danger">{errors.email}</p>}
              </div>
              <div className="form-group col-md-6 mb-5">
                <input
                  type="text"
                  name="companyname"
                  id="companyname"
                  onChange={(e) => handleChange(e)}
                  value={values.companyname}
                  className={errors.companyname ? 'form-control is-invalid' : 'form-control'}
                  placeholder="Company Name"
                />
                {errors.companyname && <p className="text-danger">{errors.companyname}</p>}
              </div>
              <div className="form-group col-md-12 mb-5">
                I’m interested in the following (check all that apply):
                <div className="form-check ">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="webapp"
                    id="webapp"
                    onChange={handleCheckBoxChange}
                    value="Web App Development"
                  />
                  <label className="form-check-label">Web App Development</label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="mobileapp"
                    id="mobileapp"
                    onChange={(e) => handleCheckBoxChange(e)}
                    value="Mobile App Development"
                  />
                  <label className="form-check-label">Mobile App Development</label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="developer"
                    id="developer"
                    onChange={(e) => handleCheckBoxChange(e)}
                    value="Looking for a developer"
                  />
                  <label className="form-check-label">Looking For A Developer</label>
                </div>
              </div>
              <div className="form-group col-md-12 mb-5">
                <textarea
                  name="message"
                  id="message"
                  onChange={(e) => handleChange(e)}
                  value={values.message}
                  className={errors.message ? 'form-control is-invalid' : 'form-control'}
                  rows="5"
                  placeholder={props.page === 'contact' ? 'Your Message' : 'Tell Us Your Requirement'}
                ></textarea>
                {errors.message && (
                  <p className="text-danger">{props.page === 'contact' ? 'Required Your Message' : 'Required Your Requirements'}</p>
                )}
              </div>
              <div className="col-md-12">
                <button type="submit" disabled={isSubmitting} className="btn btn-primary">
                  Send Message
                </button>
              </div>
            </form>
          </div>
          <div className="col-lg-4 mt-4 mt-lg-0">
            <div className="bg-primary p-5 text-white">
              <h2 className="text-white font-weight-normal">Contact info</h2>
              <p className="mb-6">It would be great to hear from you! If you got any questions</p>
              <div className="media mb-4">
                <i className="ti-map-alt fa-3x"></i>
                <div className="media-body pl-4">
                  <h4 className="mt-0 mb-1 text-white">Address</h4>
                  <p>N-14-10, First Subang, Jalan SS15/4G, 47500, Subang Jaya, Selangor.</p>
                </div>
              </div>
              <div className="media mb-4">
                <i className="ti-email fa-3x"></i>
                <div className="media-body pl-4">
                  <h4 className="mt-0 mb-1 text-white">Email</h4>
                  <p>simon.siah@shsolutions.co</p>
                </div>
              </div>
              <div className="media">
                <i className="ti-mobile fa-3x"></i>
                <div className="media-body pl-4">
                  <h4 className="mt-0 mb-1 text-white">Mobile Number</h4>
                  <p>+6 016 201 4403</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
